<app-main-page>
 <app-machines-list></app-machines-list>
</app-main-page>
